import { InfoIcon } from 'lucide-react';

export default function DiagnosticsDisabled() {
    return (
        <div className="mx-auto max-w-4xl w-full sm:w-auto sm:min-w-[28rem] relative overflow-hidden z-40 p-6 pr-10 flex items-center justify-between space-x-4 rounded-xl border shadow-lg transition-all text-black/75 dark:text-white/90 border-destructive/70 bg-destructive-hint">
            <div className="flex-shrink-0 flex flex-col gap-2 items-center">
                <InfoIcon className="w-8 h-8 text-destructive-foreground" />
            </div>
            <div className="flex-grow">
                <div className="font-semibold">Diagnostics Disabled</div>
                <div className="mt-1 text-sm text-destructive-foreground/85 font-mono">
                    This Diagnostics report is disabled in this modified build of txAdmin. Some original features are intentionally turned off for safety and compatibility.
                </div>
            </div>
        </div>
    );
}
